// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = () => ({
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  boldText: {
    fontFamily: `${GlobalStyles.fonts.FONT_ANLTP_BOLD} !important`
  },
  postcodeContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  descriptionContainer: {
    margin: '10px 30px',
  },
  descriptionOrdersContainer: {
    margin: '10px 10px',
  },
  link: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_SECONDARY,
    }
  },
});

export default styles;
